import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

type GetLineItemQuantityAlreadyRejectedByMerchantParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * For a given line item, returns the quantity that has already been rejected by a merchant.
 * To get it, we look at any action that has been done by a merchant on the line item
 * that has the status "rejected" and we sum the quantity of all these actions.
 */
export function getLineItemQuantityAlreadyRejectedByMerchant({
  lineItem,
}: GetLineItemQuantityAlreadyRejectedByMerchantParams) {
  return lineItem.merchant_informations.reduce((acc, merchantInformation) => {
    if (merchantInformation.status === "rejected") {
      return acc + merchantInformation.quantity;
    }
    return acc;
  }, 0);
}
